export const fieldTranslations: Record<string, string> = {
  date: "Date",
  c3_static_datum_name: "Actif",
  c3_static_datum_id: "ID de l'actif",
  fixing: "Prix unitaire",
  market_value: "Valorisation",
  aum: "AUM",
  aum_currency: "Devise de l'AUM",
  currency: "Devise",
  created_at: "Créé le",
  updated_at: "Mis à jour le",
};

export default fieldTranslations;
